import { IItinerary, deepCloneObject } from "@thekilroygroup/shared-ui";
import {
  emptyGeneralTraveler,
  emptyStudentTraveler,
  ITraveler,
} from "redux/travelerInformation";

/**
 * Creates a list of travelers in the store.
 *
 * If there's already one it is beeing cleared before the new one is generated.
 * @param itinerary
 */
export const setupTravelers = (
  itinerary: IItinerary,
  currentTravelers: ITraveler[] = [],
) => {
  const newTravelersList: ITraveler[] = [];
  let travelerCount = 0;

  itinerary?.fareBreakdowns.forEach((traveler) => {
    for (let index = 0; index < traveler.passengerQuantity; index++) {
      if (traveler.passengerType === "STU") {
        newTravelersList.push({
          ...deepCloneObject(
            currentTravelers[travelerCount]?.passengerType ===
              traveler.passengerType
              ? currentTravelers[travelerCount]
              : emptyStudentTraveler,
          ),
          passengerType: traveler.passengerType,
        });
      } else {
        newTravelersList.push({
          ...deepCloneObject(
            currentTravelers[travelerCount]?.passengerType ===
              traveler.passengerType
              ? currentTravelers[travelerCount]
              : emptyGeneralTraveler,
          ),
          passengerType: traveler.passengerType,
        });
      }
      travelerCount++;
    }
  });
  return newTravelersList;
};
